import { render, staticRenderFns } from "./netConfig.vue?vue&type=template&id=ef07e2a6&scoped=true"
import script from "./netConfig.vue?vue&type=script&lang=js"
export * from "./netConfig.vue?vue&type=script&lang=js"
import style0 from "./netConfig.vue?vue&type=style&index=0&id=ef07e2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef07e2a6",
  null
  
)

export default component.exports